import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'shared/components/text';
import { Image } from 'shared/components/image';
import { useLocale } from 'shared/library/i18n/use-locale';
import tractiveDogAdventureImage from 'shared/assets/brands/tractive/dog-xl-adventure-edition.jpg';
import { withNativeGradientFallback } from 'shared/library/native-gradient';
import { TractiveProductImage } from './tractive-product-image';

export function ShopHomeTractiveBanner() {
  const { t } = useTranslation('components');
  const { languageCode } = useLocale();

  if (languageCode !== 'sv') return null;

  return (
    <View
      testID={'shop-home-tractive-banner'}
      className={'bg-brand-cream-dark mt-3 overflow-hidden rounded md:mt-6 md:rounded-xl'}
    >
      <View className={'md:flex-row'}>
        <View className={'z-10 p-5 md:flex-1 md:self-stretch md:p-6 lg:px-8 lg:py-7'}>
          <View className={'bg-brand-brown-dark self-start rounded-full px-3 py-1'}>
            <Text className={'text-xs font-black uppercase tracking-wide text-white md:text-sm'}>
              {t('shop.shop_home_hero.shop_home_banner.kicker')}
            </Text>
          </View>

          <Text
            className={
              'text-brand-brown-dark mt-4 max-w-lg text-2xl font-black tracking-tight md:text-3xl lg:text-4xl'
            }
          >
            {t('shop.shop_home_hero.shop_home_banner.title')}
          </Text>

          <Text className={'text-brand-brown-dark/80 mt-4 max-w-lg text-lg'}>
            {t('shop.shop_home_hero.shop_home_banner.description')}
          </Text>

          <Text
            className={'text-brand-brown-dark/60 mt-2 max-w-lg text-xs italic leading-5 md:text-sm'}
          >
            {t('shop.shop_home_hero.shop_home_banner.disclaimer')}
          </Text>
        </View>

        <View className={'relative min-h-[18rem] md:min-h-[16rem] md:flex-1'}>
          <View
            className={withNativeGradientFallback(
              'from-brand-brown-dark/60 via-brand-brown-dark/10 absolute inset-0 z-10 bg-gradient-to-r to-transparent',
              'bg-brand-brown-dark/25',
            )}
          />
          <View
            className={withNativeGradientFallback(
              'from-brand-brown-dark/45 absolute inset-0 z-10 bg-gradient-to-t via-transparent to-transparent',
              'bg-brand-brown-dark/15',
            )}
          />

          <Image
            src={tractiveDogAdventureImage}
            alt={t('shop.shop_home_hero.shop_home_banner.dog_image_alt')}
            containerClassName={'absolute inset-0'}
            imageClassName={'object-cover object-[52%_center]'}
          />

          <View
            className={
              'absolute bottom-4 left-4 z-20 max-w-[13rem] md:bottom-6 md:left-6 md:max-w-[16rem]'
            }
          >
            <Text className={'text-brand-cream-light text-xl font-black leading-tight md:text-2xl'}>
              {t('shop.shop_home_hero.shop_home_banner.reward_title')}
            </Text>
            <Text className={'text-brand-cream-light/80 mt-1 text-sm leading-5'}>
              {t('shop.shop_home_hero.shop_home_banner.reward_description')}
            </Text>
          </View>

          <View className={'absolute bottom-0 right-1 z-20 w-36 md:bottom-1 md:right-3 md:w-52'}>
            <TractiveProductImage
              alt={t('shop.shop_home_hero.shop_home_banner.product_image_alt')}
            />
          </View>
        </View>
      </View>
    </View>
  );
}
